export default __webpack_public_path__ + "static/media/Pilgrim's Headband.63ad4c7d.jpg";